import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = typeof window !== "undefined" && window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={
        isHorizontal
          ? `full-width-tabpanel-${index}`
          : `vertical-tabpanel-${index}`
      }
      aria-labelledby={
        isHorizontal ? `full-width-tab-${index}` : `vertical-tab-${index}`
      }
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return isHorizontal
    ? {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
      }
    : {
        id: `vertical-tab-${index}`
      };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "transparent",
    display: "flex",
    minHeight: 480
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    "Security Researcher": {
      jobTitle: "",
      duration: "2025 – Present",
      desc: [
        "Google OSS VRP (Apr 2026 – Present): Discovered two zero-day Remote DoS vulnerabilities in the Go (Golang) standard library (net/http and html/template), both officially accepted and remediated. Contributed code fixes to Go open-source project.",
        "Apple Security (2026): Discovered and reported a vulnerability in Apple WebKit, which was triaged and resolved by the Apple Security team.",
        "Bug Bounty (2025 – Present): Reported 10+ valid vulnerabilities (high/critical severity like ATO and business logic flaws) across production applications on YesWeHack & private programs, earning Hall of Fame recognition from the French Government, Zivver, and Onfido."
      ]
    },

    "Deep Strike": {
      jobTitle: "Offensive Security Engineer @",
      duration: "Nov 2025 – Present",
      desc: [
        "Conduct manual web and network penetration tests across enterprise targets, identifying vulnerabilities including XSS, IDOR, SQL Injection, SSRF, and HTTP request smuggling.",
        "Discover access control flaws and rate-limit bypass issues to prevent unauthorized data exposure.",
        "Chain multiple low-severity vulnerabilities into high/critical impact attack paths."
      ]
    },

    "Al Dahra Holding": {
      jobTitle: "Software Engineer Intern @",
      duration: "Aug 2025 – Sep 2025",
      desc: [
        "Built Python-based data processing pipelines powering a live analytics dashboard for real-time operational insights."
      ]
    },

    "Vodafone": {
      jobTitle: "Machine Learning Intern @",
      duration: "Aug 2025 – Sep 2025",
      desc: [
        "Built Decision Tree and Random Forest models on 5,000+ records for employee attrition prediction."
      ]
    },

    "Ejada": {
      jobTitle: "Software Engineer Intern @",
      duration: "Aug 2026 – Sep 2026",
      desc: [
        "Contributed to software development tasks within an enterprise engineering team, gaining exposure to secure coding practices and the software development lifecycle."
      ]
    },

    "ICT Misr": {
      jobTitle: "Network Intern @",
      duration: "Jul 2026 – Sep 2026",
      desc: [
        "Assisted in configuring and maintaining network infrastructure, gaining hands-on exposure to network administration and security fundamentals."
      ]
    },

    "Hackviser": {
      jobTitle: "Offensive Security Practice @",
      duration: "2025 – Present",
      desc: [
        "Completed all CAPT and CWSE labs and machines, specializing in manual exploitation and vulnerability chaining.",
        "Ranked in the Top 1% Globally on the Hackviser platform."
      ]
    },

    "Certificates": {
      jobTitle: "Certified Professional @",
      duration: "2025 – Present",
      desc: [
        "CAPT (Certified Active Penetration Tester) — Hackviser.",
        "CWSE (Certified Web Security Expert) — Hackviser.",
        "ITI Maharatech: Cloud Concepts, Cybersecurity Basics, Network Security, Web Penetration Testing, OWASP Top 10, Ethical Hacking.",
        "Google: AI for Business."
      ]
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={isHorizontal ? "horizontal" : "vertical"}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab
            key={key}
            label={isHorizontal ? `0${i}.` : key}
            {...a11yProps(i)}
          />
        ))}
      </Tabs>

      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel key={key} value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key].jobTitle + " "}
          </span>
          <span className="joblist-job-company">{key}</span>

          <div className="joblist-duration">
            {experienceItems[key].duration}
          </div>

          <ul className="job-description">
            {experienceItems[key].desc.map((descItem, j) => (
              <FadeInSection key={j} delay={`${j + 1}00ms`}>
                <li>{descItem}</li>
              </FadeInSection>
            ))}
          </ul>
        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
